import {Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {PaiementModel} from '../models/paiement.model';
import {FormGeneratorService, StoreService} from '@ngx-resource-toolkit/core';
import {FormGroup} from '@angular/forms';
import {Subscription} from 'rxjs/Subscription';
import {isOneOfSelectOptionsNull, SelectActions} from '../../resource/select.store';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../../environments/environment';
import {IMyDateModel} from 'ngx-mydatepicker';

@Component({
    selector: 'create-paiement',
    templateUrl: './create.component.html',
    styleUrls: ['./create.component.scss']
})
export class CreatePaiementComponent implements OnInit, OnChanges {
    @ViewChild('auto') auto;
    @Input() public model: PaiementModel;
    @Input() public form: FormGroup;
    @Input() public mode: string;

    private tireurOrigine: String;
    public typesPaiements = [];
    private typePaiementSub: Subscription;

    public datePickerOptions = {
        todayBtnTxt: 'Aujourd\'hui',
        dateFormat: 'dd/mm/yyyy',
        firstDayOfWeek: 'mo',
        dayLabels: { su: 'Dim', mo: 'Lun', tu: 'Mar', we: 'Mer', th: 'Jeu', fr: 'Ven', sa: 'Sam' },
        monthLabels: { 1: 'Janvier', 2: 'Février', 3: 'Mars', 4: 'Avril', 5: 'Mai', 6: 'Juin', 7: 'Juillet', 8: 'Août', 9: 'Septembre', 10: 'Octobre', 11: 'Novembre', 12: 'Décembre' },
    };

    public dataEtabPayeur = [];
    public dataLieuEtabPayeur = [];
    public montantPaiement: string;

    constructor(
        private formGenerator: FormGeneratorService,
        private store: StoreService,
        private http: HttpClient,
        ) {    }

    ngOnChanges(changes: SimpleChanges): void {
        // throw new Error("Method not implemented.");
        console.log({ ou: 'CreatePaiementComponent.ngOnChanges', changes, mode: this.mode });
        /*if (changes.form) {
            console.log('form changed');
            if (this.form.value.datePrevEncaiss) {
                const datePrevEncaiss = moment(this.form.value.datePrevEncaiss);
                console.log(datePrevEncaiss.toJSON());
                if (!this.form.value.datePrevEncaissTransient) {
                    console.log('datePrevEncaissTransient absent => il faut le créer');
                    // Si le champ datePrevEncaissTransient n'est pas renseigné => on le calcule (c'est le cas pour la consultation à priori)
                    this.form.patchValue({
                        datePrevEncaissTransient: {
                            date: {
                                year: datePrevEncaiss.year(),
                                month: datePrevEncaiss.month() + 1,
                                day: datePrevEncaiss.date()
                            }
                        }
                    });
                }
            }
        }*/
    }
    ngOnInit(): void {
        // throw new Error("Method not implemented.");
        console.log({ ou: 'CreatePaiementComponent.ngOnInit', model: this.model, form: this.form, mode: this.mode });
        this.initListes();
    }

    initListes() {
        this.typePaiementSub = this.store.getState(state => state.selectOptions)
            .do(selectOptions => {
                if (isOneOfSelectOptionsNull(selectOptions)) {
                    this.store.dispatch(
                        SelectActions.fetch({
                            http: this.http,
                        })
                    );
                }
            })
            .filter(selectOptions => !isOneOfSelectOptionsNull(selectOptions))
            .subscribe(data => {
                this.typesPaiements = data['typesPaiements'];
                console.log({ typesPaiements: this.typesPaiements});
            });
        this.searchEtabPayeur();
    }

    public isError(chp: string): boolean {
        if (!this.form || !this.form.get(chp)) {
            console.log({ ou: 'isError', pourquoi: 'champ inconnu', chp });
        }
        return this.form && this.form.get(chp)
            ? this.form.get(chp).invalid && this.form.get(chp).touched
            : true;
    }

    onChangeIsRemboursement() {
        // console.log({ where: 'onChangeTypePaiement', rbt: this.form.value.isRemboursement , form: this.form})
        if (this.form.value.isRemboursement == 'true') {
            // console.log("remboursement");
            this.tireurOrigine = this.form.value.tireur;
            this.form.patchValue({ tireur: 'Conservatoire'}); // Demandé par STC
        } else {
            this.form.patchValue({ tireur: this.tireurOrigine });
        }
    }
    // Date prévisionnelle d'encaissement
    onDatePrevEncaissChanged(event: IMyDateModel) {
        // console.log(event);
        if (this.form && event.epoc) {
            this.form.patchValue({
                datePrevEncaiss: event.epoc * 1000 //new Date(event.date.year, event.date.month, event.date.day).getTime() / 1000
            });
        }
    }

    // Autocomplétion Etablissement payeur
    selectEtabPayeur(item) {
        // do something with selected item
        // console.log({ ou: 'selectEtabPayeur', item });
    }
    onChangeEtabPayeur(val) {
        const etabPayeur: string = val;
        if (etabPayeur) {
            // je mettrais tout en majuscule comme pour le nom tireur
            this.form.patchValue({etabPayeur: etabPayeur.charAt(0).toUpperCase() + etabPayeur.substring(1) }, {emitEvent: false});
        }
        // fetch remote data from here
        // And reassign the 'data' which is binded to 'data' property.
        // console.log({ ou: 'onChangeEtabPayeur', val });
    }
    onFocusedEtabPayeur(e) {
        // do something when input is focused
        // console.log({ ou: 'onFocusedEtabPayeur', e });
    }
    // Autocomplétion Lieu Etablissement payeur
    selectLieuEtabPayeur(item) {
        // do something with selected item
        //console.log({ ou: 'selectLieuEtabPayeur', item });
    }
    onChangeLieuEtabPayeur(val) {
        // fetch remote data from here
        // And reassign the 'data' which is binded to 'data' property.
        //console.log({ ou: 'onChangeLieuEtabPayeur', val });
    }
    onFocusedLieuEtabPayeur(e) {
        // do something when input is focused
        //console.log({ ou: 'onFocusedLieuEtabPayeur', e });
    }
    updateAmount(val) {
        const montantPaiement: string = this.form.value['montantPaiement'];
        	if (montantPaiement) {
        		this.form.patchValue({ montantPaiement: montantPaiement.replace(',', '.') }, { emitEvent: false });
        }
    }
    upcaseTireur() {
        const tireur: string = this.form.value['tireur'];
        if (tireur) {
            this.form.patchValue({tireur: tireur.toUpperCase()}, {emitEvent: false});
        }
    }
    searchEtabPayeur() {
        this.http.get(
            environment.proxyUrl + '/reference/getReferenceObjects',
            { params: { 'params': JSON.stringify(['ref_etab_payeur']) } })
            .subscribe(data => {
                console.log(data);
                this.dataEtabPayeur =
                data instanceof Array ? data.map((option) => {
                    return option;
                }) : [];
            });
        this.http.get(
            environment.proxyUrl + '/reference/getReferenceObjects',
            { params: { 'params': JSON.stringify(['ref_lieu_etab_payeur']) } })
            .subscribe(data => {
                //console.log(data);
                this.dataLieuEtabPayeur =
                    data instanceof Array ? data.map((option) => {
                        return option;
                    }) : [];
            });
    }

    validate() {
        console.log({ where: 'paiement.create.validate'});
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/shared/paiement/create/create.component.ts